import React from 'react';
import PropTypes from 'prop-types';

import CurrencyInput from 'components/form/currency_input_wrapper';

export default class ListingQuickUpdateFormBrokerCommission extends React.Component {
  static propTypes = {
    commission: PropTypes.shape({
      brokerName: PropTypes.string.isRequired,
      grossAmount: PropTypes.number,
      grossPercent: PropTypes.number,
      grossUnit: PropTypes.string,
    }).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  handleGrossAmountChange = (_event, _, grossAmount) => {
    this.props.onChange({ grossAmount }, this.props.commission);
  }

  handleGrossPercentChange = (event) => {
    const { value } = event.target;
    const grossPercent = value === '' ? null : Math.max(0, Math.min(parseFloat(value), 100));
    this.props.onChange({ grossPercent }, this.props.commission);
  }

  handleUnitChange = (event) => {
    this.props.onChange({ grossUnit: event.target.value }, this.props.commission);
  }

  render() {
    const { brokerName, grossUnit } = this.props.commission;

    return (
      <div className="form-inline">
        <div className="form-group broker-commission-row">
          <label className="control-label">
            {brokerName}
          </label>

          {this.renderUnitInput()}

          <div className="form-input-container broker-gross" name="broker-commission-wrapper">
            {grossUnit === 'gross_unit_percent' ? this.renderGrossPercentInput() : this.renderGrossAmountInput()}
          </div>
        </div>
      </div>
    );
  }

  renderGrossAmountInput() {
    return (
      <CurrencyInput
        allowEmpty
        className="form-control"
        disabled={this.props.disabled}
        prefix=""
        value={this.props.commission.grossAmount}
        onChangeEvent={this.handleGrossAmountChange}
      />
    );
  }

  renderGrossPercentInput() {
    const { grossPercent } = this.props.commission;

    return (
      <input
        className="form-control"
        disabled={this.props.disabled}
        type="number"
        value={grossPercent == null ? '' : grossPercent}
        onChange={this.handleGrossPercentChange}
      />
    );
  }

  renderUnitInput() {
    return (
      <select
        className="form-control unit-select"
        disabled={this.props.disabled}
        value={this.props.commission.grossUnit}
        onChange={this.handleUnitChange}
      >
        <option value="gross_unit_percent">%</option>
        <option value="gross_unit_dollars">$</option>
      </select>
    );
  }
}
